const USERS = {
  LOAD_REQUEST: 'USERS_LOAD_REQUEST',
  LOAD_SUCCESS: 'USERS_LOAD_SUCCESS',
  LOAD_FAIL: 'USERS_LOAD_FAIL'
};

const USER_STATUS = {
  LOAD_REQUEST: 'USER_STATUS_LOAD_REQUEST',
  LOAD_SUCCESS: 'USER_STATUS_LOAD_SUCCESS',
  LOAD_FAIL: 'USER_STATUS_LOAD_FAIL'
};

export { USERS, USER_STATUS };



// WEBPACK FOOTER //
// ./src/constants/index.js